import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const INK = "#1A2A56", BODY = "#3d4661", MUTED = "#77839c", LINE = "#E7ECF4", ACCENT = "#5186EC";

const fmtWhen = (v) => {
  if (!v) return null;
  const d = new Date(v);
  return isNaN(d) ? null : d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
};

/**
 * Consolidated, web-search-grounded "Company Overview" written by Claude in one pass
 * (covers all the non-risk questions). Rendered at the top of the Questions tab.
 * Renders nothing until the background overview has been generated.
 */
export default function ContextOverview({ contextQA }) {
  const text = contextQA?.text;
  if (!text || !String(text).trim()) return null;
  const when = fmtWhen(contextQA?.at);

  return (
    <Box
      sx={{
        border: `1px solid ${LINE}`,
        borderRadius: "14px",
        background: "linear-gradient(180deg,#F8FAFF 0%,#FFFFFF 60%)",
        p: { xs: 2.25, md: 3 },
        mb: 3,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5, flexWrap: "wrap" }}>
        <Box sx={{ width: 30, height: 30, borderRadius: "9px", background: `${ACCENT}14`, border: `1px solid ${ACCENT}33`, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <AutoAwesomeIcon sx={{ fontSize: 17, color: ACCENT }} />
        </Box>
        <Typography sx={{ fontSize: 17, fontWeight: 700, color: INK }}>Company Overview</Typography>
        <Chip size="small" label="AI · web-researched" sx={{ height: 20, fontSize: 10.5, fontWeight: 700, color: ACCENT, background: `${ACCENT}14` }} />
        {when && <Typography sx={{ fontSize: 12, color: MUTED, ml: "auto" }}>Updated {when}</Typography>}
      </Box>

      <Box
        sx={{
          color: BODY,
          fontSize: 15,
          lineHeight: 1.7,
          maxWidth: 820,
          "& h1,& h2,& h3": { color: INK, fontSize: 15.5, fontWeight: 700, mt: 2, mb: 0.75 },
          "& p": { my: 1 },
          "& ul,& ol": { pl: 3, my: 1 },
          "& li": { mb: 0.5 },
          "& strong": { color: INK, fontWeight: 700 },
          "& a": { color: ACCENT, textDecoration: "none" },
          "& table": { borderCollapse: "collapse", my: 1.5, width: "100%" },
          "& th,& td": { border: `1px solid ${LINE}`, padding: "6px 10px", fontSize: 13.5, textAlign: "left" },
          "& th": { background: "#f4f7fc", color: INK, fontWeight: 700 },
        }}
      >
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
      </Box>
    </Box>
  );
}
